import type { ExtensionUser } from '../types/extension'
import type { AvailableTools } from '../types/prompt'

type SendToExtensionIds = 'check-auth' | 'logIn' | 'select-prompt' | 'use-prompt'

const isExtensionListenerLoaded = () => useState('extension:loaded', () => false)
export const useExtensionUser = () => useState<ExtensionUser>('extension:user')
export const useExtension = () => useState('extension:installed', () => false)
export const useShowExtensionBanner = () => useState('extension:show-banner', () => false)
export const useExtensionType = () => useState<AvailableTools>('extension:type', () => 'ChatGPT')
export const useExtensionTypeReady = () => useState('extension:type-ready', () => false)

// type IdHandler = (message: any) => void

// interface MappedExtensionIds {
//   [key: string]: IdHandler
// }

// const mappedExtensionIds: MappedExtensionIds = {
//   'check-auth': () => {

//   },
// }

export function selectPrompt(prompt: string, redirectUrl?: string) {
  sendMessageToExtension('use-prompt', { formattedText: prompt, redirectUrl })
}

export function checkIsAuthenticated() {
  sendMessageToExtension('check-auth', '')
}

function sendMessageToExtension(id: SendToExtensionIds, message?: any) {
  // Do not remove the `from` property
  // It can cause errors on the extension communication
  window.parent.postMessage({ id, message: JSON.stringify(message), from: 'sp-platform' }, { targetOrigin: '*' })
}

export function setupExtensionListener() {
  const isLoaded = isExtensionListenerLoaded()
  const isExtension = useExtension()

  if (isLoaded.value)
    return

  const isOnIFrame = window.self !== window.top

  if (isOnIFrame) {
    isExtension.value = true

    const parentUrl = window.location.ancestorOrigins[0]

    if (parentUrl.includes('gemini'))
      useExtensionType().value = 'Gemini'
    else if (parentUrl.includes('chat.openai'))
      useExtensionType().value = 'ChatGPT'
    else if (parentUrl.includes('midjourney'))
      useExtensionType().value = 'Midjourney'
  }
  else {
    // DISABLED ON 19/06
    // const showExtensionBanner = useShowExtensionBanner()
    // showExtensionBanner.value = true
  }

  isLoaded.value = true
}
